import { CollectionView } from "backbone.marionette";
import { _ } from "extensions/underscore";

import strings from "common/strings";
import { destroyPopovers } from "common/utils";

import { View as MessageRowView, Model as MessageRowModel } from "./messageRow";
import { RowView } from "./row";

export const SmartTableBody = CollectionView.extend({
    childViewEventPrefix: "childview",
    emptyView: MessageRowView,
    childView: RowView,
    childViewOptions: {},
    childViewEvents: {
        refresh() {
            this.collection.fetch();
        }
    },
    initialize() {
        const isLocked = this.getOption("locked");
        const columns = isLocked ? this.model.lockedColumns.toJSON() : this.model.staticColumns.toJSON();

        if (columns.length) {
            this.childViewOptions = this.model.toJSON();
            this.childViewOptions.columns = columns;

            this.messageRowModel = new MessageRowModel({
                colspan: columns.length
            });

            // If the collection is already fetched, immediately check for number of views
            if (this.collection.length || this.collection.fetched) {
                this.on("render", this.checkEmptyView);
            }

            this.listenTo(this.collection, "sync destroy", this.checkEmptyView);
            
            // Remove empty row message when collection is about to be fetched
            this.listenTo(this.collection, "before:fetched", this.onRemoveEmpty);
            
            // Display fetch error
            this.listenTo(this.collection, "fetchError", ({ reason, status }) => {
                const message = this.makeMessageCollectionFetchError(reason, status);
                if (message) {
                    this.messageRowModel.set({ message });
                }
            });
        }

        this.on({
            "render:empty": () => { this.showingEmptyView = true; },
            "destroy:empty": () => { this.showingEmptyView = false; }
        });
    },
    
    makeMessageCollectionFetchError(reason, status) {
        // Don't show the error if request is aborted by us
        if ([0, 504].includes(status)) return strings.genericRefreshErrorStr;
        
        if (status === 403) return strings.viewTransactionsDisabled;
        
        return strings.common.errors.internal;
    },

    /**
     * Check if collection finished syncing and we can remove the loader and add no-items message if necessary
     */
    checkEmptyView() {
        // If there are no rendered children then set a message on the message row to remove spinning loader
        if (!this.children.some((c) => c.isRendered())) {
            this.messageRowModel.set({
                message: this.model.get("noDataMessage")
            });
        }
    },

    viewFilter(child, index) {
        const limitRows = this.model.get("limitRows");
        const filterRows = this.model.get("filterRows");
        let isMatchedByFilter = true;
        let isUnderRowLimit = true;

        if (_.isFunction(filterRows)) {
            isMatchedByFilter = filterRows(child.model);

            // Reset counter if index is zero
            if (index === 0) {
                this.counter = 0;
            }

            // Issue here is that item can be filtered out, but then counted towards limitRows, therefore this two
            // checks are separated from each other
            if (isMatchedByFilter) {
                this.counter = this.counter + 1;
            }

            if (this.counter > limitRows) {
                isMatchedByFilter = false;
            }
        } else if (_.isNumber(limitRows)) {
            isUnderRowLimit = (index + 1) <= limitRows;
        }

        return isUnderRowLimit && isMatchedByFilter;
    },

    emptyViewOptions() {
        return {
            model: this.messageRowModel
        };
    },

    onRemoveEmpty() {
        this.messageRowModel.unset("message");
    },

    onBeforeRenderChildren() {
        destroyPopovers();
    },

    onRenderChildren() {
        // Run after callback
        if (typeof this.model.get("afterRender") === "function") {
            this.model.get("afterRender").call(this, this.collection, this.children);
        }
    }
});
